import { locationsApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const NON_US_LOCATIONS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/nonUSLocations`,
  {
    GET_LOCATIONS: 'GET_LOCATIONS',
  },
);

export const getNonUSLocationsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await locationsApi.getNonUSCountries();

  return dispatch({
    type: NON_US_LOCATIONS_ACTION_TYPE.GET_LOCATIONS,
    payload: data,
  });
});
